import request from '@/utils/request'

//财务类首页-财务进度
export function cwjdSearch(url){
  return request({
      url,
      methods:'get'
  })
} 
//财务类-凭证查看-列表
export function pzSearch(url){
  return request({
      url,
      methods:'get'
  })
} 
//财务类首页-收支公开榜
export function szgkSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-结账进度榜
export function jzjdSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-财务报表
export function cwbbSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-内部往来公开榜
export function nbwlgkSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-现金银行逐笔公开榜
export function xjyhzbgkSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-应付款逐笔逐项公开榜
export function yfkSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-应收逐笔逐项公开榜
export function ysSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务类首页-应付福利费逐笔逐项公开榜
export function yfflfSearch(url){
  return request({
      url,
      methods:'get'
  })
} 

//收支公开榜-列表
export function szgkPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//结账进度榜-列表
export function jzjdPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务报表-列表
export function cwbbPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务报表-收益及收益分配表-列表
export function syfpbPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//财务报表-资产负债表-列表
export function zcfzPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//内部往来公开榜-列表
export function nbwlgkPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//现金银行逐笔公开榜-列表
export function xjyhzbgkPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//应付款逐笔逐项公开榜-列表
export function yfkPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//应收逐笔逐项公开榜-列表
export function ysPage(url){
  return request({
      url,
      methods:'get'
  })
} 

//应付福利费逐笔逐项公开榜-列表
export function yfflfPage(url){
  return request({
      url,
      methods:'get'
  })
} 